import { Flex } from "@/atoms"

import styles from "./AdrIncidentsWidget.module.scss"

import type { CardAdrIncidentsWidgetProps } from "."

export const CardAdrIncidentsWidget = (props: CardAdrIncidentsWidgetProps) => {
  const { icon, text } = props

  return (
    <Flex className={styles.card}>
      <Flex flex={1} align="center" gap={12}>
        <div className={styles.dot}></div>
        <span>{text}</span>
      </Flex>
      <span className={styles.icon}>{icon}</span>
    </Flex>
  )
}
